/* eslint-disable no-unused-expressions */
import {
    FETCH_DISCOUNT_COUPON,
    FETCH_PURCHASE_DATA,
    FETCH_PAYMENT_INFO,
    ADD_INSURED_FORM,
    REMOVE_INSURED_FORM,
    FETCH_PAYMENT_METHODS,
    SELECT_PAYMENT_METHOD,
    SELECT_BANK,
    CLEAR_COUPON,
    CHANGE_INSURED_FORM_ATTR,
    CHANGE_CONTACT_ATTR,
    FETCH_BENEFITS_METHODS,
    SELECT_CREDITCARD_BRAND,
    SELECT_CREDITCARD_PARCEL,
    CHANGE_CREDITCARD_ATTR,
    CHANGE_BOLETO_ATTR,
    CHANGE_SAFETYPAY_ATTR,
    FETCH_PLANS_PURCHASE,
    CHANGE_CASH_ATTR,
    CHANGE_PIX_ATTR,
    UPDATE_PURCHASE_SUMMARY,
    FINISH_PURCHASE,
    SET_QUOTATION_PARAMS,
    SET_PARTNER,
    SET_COUPON_TEXT,
    VALIDATE_PURCHASE,
    SET_PURCHASE_UUID,
    FETCH_ADDRESS,
    CLEAR_ALERTS,
    START_PURCHASE_LOADING,
    END_PURCHASE_LOADING,
    OPEN_DETAIL_MODAL,
    CLOSE_DETAIL_MODAL,
    OPEN_MODAL_PURCHASE_ERROR,
    OPEN_MODAL_COUPON_ERROR,
    OPEN_MODAL_PURCHASE_DATE_ERROR,
    OPEN_MODAL_GENERIC_ERROR,
    CLOSE_MODAL_PURCHASE_ERROR,
    CLOSE_MODAL_COUPON_ERROR,
    CLOSE_MODAL_PURCHASE_DATE_ERROR,
    CLOSE_MODAL_GENERIC_ERROR,
    OPEN_MODAL_TERMS_OF_USE,
    CLOSE_MODAL_TERMS_OF_USE,
    OPEN_MODAL_SAFETYPAY,
    CLOSE_MODAL_SAFETYPAY,
    OPEN_MODAL_FRANCHISE,
    CLOSE_MODAL_FRANCHISE,
    OPEN_MODAL_OPERATOR_CONFIRMATION,
    CLOSE_MODAL_OPERATOR_CONFIRMATION,
    OPEN_MODAL_STUDENT,
    CLOSE_MODAL_STUDENT,
    OPEN_MODAL_PLAN_RULES,
    CLOSE_MODAL_PLAN_RULES,
    SET_USER_DETAILS,
    CHANGE_CONFIRM_TERMS,
    CLEAN_ERRORS,
    NEXT_STAGE_PURCHASE_MOBILE,
    STAGE_PAYMENT_CREDIT_CARD,
    STAGE_PAYMENT_CASH_TRANSFER,
    EDIT_PURCHASE,
    BACK_STAGE_PURCHASE,
    SELECT_PAYMENT_ALTER_STATE,
    BACK_STAGE_PAYMENT_METHOD,
    CLEAN_STATES_PURCHASE_MOBILE,
    VALIDATOR_HANDLER_BLUR,
    GET_INFOS_PROSPECT,
    CLEAR_INFOS_PROSPECT,
    GET_INFOS_INSUREDS,
    SET_INFOS_PROSPECT_IN_PURCHASE,
    OPEN_MODAL_TRAVEL_RENEWAL,
    CLOSE_MODAL_TRAVEL_RENEWAL,
    OPEN_MODAL_RENEWAL_FRANCHISE,
    CLOSE_MODAL_RENEWAL_FRANCHISE,
    OPEN_MODAL_RECEPTIVE_PRODUCT,
    CLOSE_MODAL_RECEPTIVE_PRODUCT,
    OPEN_MODAL_NOT_COVID_COVERAGE,
    CLOSE_MODAL_NOT_COVID_COVERAGE,
    SHOW_INVALID_CREDIT_CARD_ERROR,
    HIDE_INVALID_CREDIT_CARD_ERROR,
    SET_BENEFITS,
    PURCHASE_GET_PAYMENT_METHODS,
    OPEN_MODAL_FAIL_PAYMENT,
    CLOSE_MODAL_FAIL_PAYMENT,
    SET_OPERATOR_CONFIRMATION_CLICKED,
    SET_UPSELL_PURCHASE,
    FETCH_FIRST_ACTIVE_CREDIT_COUPON_SUCCESS,
    FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR,
    SET_CREDIT_COUPON_CODE_TEXT,
    APPLY_CREDIT_COUPON_SUCCESS,
    APPLY_CREDIT_COUPON_ERROR,
    REMOVE_APPLIED_CREDIT_COUPON,
} from '../actions/actionTypes';

import { getProductQuotation } from '../apiCalls'
import { getCookie } from '../utils';
import matomoTracker from '../utils/matomo';


// #setting payment methods
export const getPaymentMethodsAvaliable = (data) => ({
    type: PURCHASE_GET_PAYMENT_METHODS,
    data: data
})
// #region Coupon
export const fetchDiscountCoupon = (coupon) => ({
    type: FETCH_DISCOUNT_COUPON,
    coupon
})

export const clearCoupon = () => ({
    type: CLEAR_COUPON
})
// #endregion

export const fetchFirstActiveCreditCoupon = () => {
  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_SAFEAREA_BASE_API_URL}/safearea/api/v1/credit-coupons/active/first/`;

      const response = await fetch(url, {
        credentials: 'include',
      });

      const responseBody = await response.json();

      if (response.ok) {
        dispatch({ type: FETCH_FIRST_ACTIVE_CREDIT_COUPON_SUCCESS, payload: responseBody });
      } else {
        dispatch({ type: FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR, payload: responseBody });
      }
    } catch (error) {
      const payload = {
        msg: 'Ocorreu um erro ao buscar o cupom de crédito. Por favor, tente novamente mais tarde.',
      };
      dispatch({ type: FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR, payload: payload });
    }
  };
};

export const applyCreditCoupon = (code) => {
  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_SAFEAREA_BASE_API_URL}/safearea/api/v1/credit-coupons/${code}/`;

      const response = await fetch(url, {
        credentials: 'include',
      });

      const responseBody = await response.json();

      if (response.ok) {
        dispatch({ type: APPLY_CREDIT_COUPON_SUCCESS, payload: responseBody });
      } else {
        const payload = {
          msg: responseBody.message,
        };
        dispatch({ type: APPLY_CREDIT_COUPON_ERROR, payload });
      }
    } catch (error) {
      const payload = {
        msg: 'Ocorreu um erro ao buscar o cupom de crédito. Por favor, tente novamente mais tarde.',
      };
      dispatch({ type: APPLY_CREDIT_COUPON_ERROR, payload: payload });
    }
  };
};

export const removeAppliedCreditCoupon = () => ({
    type: REMOVE_APPLIED_CREDIT_COUPON
})

export const setCreditCouponCode = (code) => ({
  type: SET_CREDIT_COUPON_CODE_TEXT,
  value: code,
});

// #region InsuredRegister
export const addInsuredForm = (form) => ({
    type: ADD_INSURED_FORM,
    form: {
        rg: '',
        cpf: '',
        name: '',
        birth_date: '',
        document_type: 'cpf',
        incoming: '',
    }
})

export const removeInsuredForm = (id) => ({
    type: REMOVE_INSURED_FORM,
    formIndex: id
})

export const changeInsuredFormAttr = (field) => ({
    type: CHANGE_INSURED_FORM_ATTR,
    field: field.name,
    value: field.value,
    formIndex: field.formId
})
// #endregion

// #region PaymentMethods
export const fetchPaymentMethods = (data) => ({
    type: FETCH_PAYMENT_METHODS,
    paymentMethods: data.payment_methods,
    extra: data.extra,
})

export const selectPaymentMethod = (methodIndex) => ({
    type: SELECT_PAYMENT_METHOD,
    methodIndex
})
// #endregion

// #region CreditCard
export const changeCreditCardAttr = (field) => ({
    type: CHANGE_CREDITCARD_ATTR,
    field: field.name,
    value: field.value
})

export const selectCreditCardParcel = (index) => ({
    type: SELECT_CREDITCARD_PARCEL,
    parcel_index: index,
})

export const selectCreditCardBrand = (index) => ({
    type: SELECT_CREDITCARD_BRAND,
    brand_index: index
})
// #endregion

// #region Boleto
export const changeBoletoAttr = (field) => ({
    type: CHANGE_BOLETO_ATTR,
    field: field.name,
    value: field.value
})
// #endregion

// #region CashTransfer
export const selectBank = (bankIndex) => ({
    type: SELECT_BANK,
    bankIndex
})

export const changeCashTransferAttr = (field) => ({
    type: CHANGE_SAFETYPAY_ATTR,
    field: field.name,
    value: field.value
})
// #endregion

// #region Cash
export const changeCashAttr = (field) => ({
    type: CHANGE_CASH_ATTR,
    field: field.name,
    value: field.value
})
// #endregion

// #region pix
export const changePixAttr = (field) => ({
    type: CHANGE_PIX_ATTR,
    field: field.name,
    value: field.value
})

// #region Contact
export const changeContactAttr = (field) => ({
    type: CHANGE_CONTACT_ATTR,
    field: field.name,
    value: field.value
})

export const fetchBenefitsList = (benefits) => ({
    type: FETCH_BENEFITS_METHODS,
    benefits
})
// #endregion

// #region
export const fetchPaymentInfo = (paymentInfo) => ({
    type: FETCH_PAYMENT_INFO,
    paymentInfo
})
// #endregion

export const fetchPlansPurchase = (plan, context) => ({
    type: FETCH_PLANS_PURCHASE,
    context,
    plan,
})

export const updatePurchaseSummary = (purchaseSummary) => ({
    type: UPDATE_PURCHASE_SUMMARY,
    purchaseSummary
})

export const finishPurchase = () => dispatch => new Promise((resolve) => {
    dispatch({
        type: FINISH_PURCHASE,
    });
    resolve();
})

export const setPartner = (partner) => ({
    type: SET_PARTNER,
    partner
})

export const setCouponText = (value) => ({
    type: SET_COUPON_TEXT,
    value
})

export const setQuotationParams = ({
    begin_date, end_date, destination, product_code, context, queryParams
}) => {
    getProductQuotation({
        begin_date,
        end_date,
        destination,
        product_code,
        context
    })

    return {
        type: SET_QUOTATION_PARAMS,
        departure_date: begin_date,
        return_date: end_date,
        destination,
        product_code,
        queryParams
    }
}

export const setPurchaseUuid = (uuid) => ({
    type: SET_PURCHASE_UUID,
    uuid,
})

export const validatePurchase = (isValid, status, message) => ({
    type: VALIDATE_PURCHASE,
    purchaseIsValid: isValid,
    status,
    message
})

export const fetchAddress = ({
    tipo_logradouro, bairro, cidade, uf, logradouro
}) => ({
    type: FETCH_ADDRESS,
    address: `${tipo_logradouro} ${logradouro}`,
    district: bairro,
    city: cidade,
    state: uf.toUpperCase(),
})

export const clearAlerts = () => ({
    type: CLEAR_ALERTS,
})

export const sendingPurchase = () => ({
    type: START_PURCHASE_LOADING
})

export const finishedPurchase = () => ({
    type: END_PURCHASE_LOADING
})

export const openModalDetail = () => ({
    type: OPEN_DETAIL_MODAL
})

export const closeModalDetail = () => ({
    type: CLOSE_DETAIL_MODAL
})

export const openModalPurchaseError = () => ({
    type: OPEN_MODAL_PURCHASE_ERROR
})

export const openModalCouponError = () => ({
    type: OPEN_MODAL_COUPON_ERROR
})

export const openModalPurchaseDateError = () => ({
    type: OPEN_MODAL_PURCHASE_DATE_ERROR
})

export const openModalGenericError = () => ({
    type: OPEN_MODAL_GENERIC_ERROR
})

export const openModalPlanRules = () => ({
    type: OPEN_MODAL_PLAN_RULES
})

export const openModalFailPayment = () => ({
    type: OPEN_MODAL_FAIL_PAYMENT
})

export const closeModalPlanRules = () => ({
    type: CLOSE_MODAL_PLAN_RULES
})

export const closeModalFailPayment = () => ({
    type: CLOSE_MODAL_FAIL_PAYMENT
})

export const showInvalidCreditCardError = () => ({
    type: SHOW_INVALID_CREDIT_CARD_ERROR
})

export const hideInvalidCreditCardError = () => ({
    type: HIDE_INVALID_CREDIT_CARD_ERROR
})

export const closeModalPurchaseError = () => ({
    type: CLOSE_MODAL_PURCHASE_ERROR
})

export const closeModalCouponError = () => ({
    type: CLOSE_MODAL_COUPON_ERROR
})

export const closeModalPurchaseDateError = () => ({
    type: CLOSE_MODAL_PURCHASE_DATE_ERROR
})

export const closeModalGenericError = () => ({
    type: CLOSE_MODAL_GENERIC_ERROR
})

export const openModalFranchise = () => ({
    type: OPEN_MODAL_FRANCHISE
})

export const closeModalFranchise = () => ({
    type: CLOSE_MODAL_FRANCHISE
})

export const openModalOperatorConfirmation = () => ({
    type: OPEN_MODAL_OPERATOR_CONFIRMATION
})

export const closeModalOperatorConfirmation = () => ({
    type: CLOSE_MODAL_OPERATOR_CONFIRMATION
})

export const openModalNotCovidCoverage = () => ({
    type: OPEN_MODAL_NOT_COVID_COVERAGE
})

export const closeModalNotCovidCoverage = () => ({
    type: CLOSE_MODAL_NOT_COVID_COVERAGE
})

export const openModalStudent = () => ({
    type: OPEN_MODAL_STUDENT
})


export const closeModalStudent = () => ({
    type: CLOSE_MODAL_STUDENT
})

export const openModalTermsOfUse = () => ({
    type: OPEN_MODAL_TERMS_OF_USE
})

export const closeModalTermsOfUse = () => ({
    type: CLOSE_MODAL_TERMS_OF_USE
})

export const openModalSafetypay = () => ({
    type: OPEN_MODAL_SAFETYPAY
})

export const closeModalSafetypay = () => ({
    type: CLOSE_MODAL_SAFETYPAY
})

export const openModalTravelRenewal = () => ({
    type: OPEN_MODAL_TRAVEL_RENEWAL
})

export const closeModalTravelRenewal = () => ({
    type: CLOSE_MODAL_TRAVEL_RENEWAL
})

export const openModalRenewalFranchise = () => ({
    type: OPEN_MODAL_RENEWAL_FRANCHISE
})

export const closeModalRenewalFranchise = () => ({
    type: CLOSE_MODAL_RENEWAL_FRANCHISE
})

export const openModalReceptiveProduct = () => ({
    type: OPEN_MODAL_RECEPTIVE_PRODUCT
})

export const closeModalReceptiveProduct = () => ({
    type: CLOSE_MODAL_RECEPTIVE_PRODUCT
})

export const fetchPurchaseData = data => ({
    type: FETCH_PURCHASE_DATA,
    data
})

export const setUserDetails = (data) => ({
    type: SET_USER_DETAILS,
    userDetails: data,
})

export const changeConfirmTerms = (dateTime) => ({
    type: CHANGE_CONFIRM_TERMS,
    dateTimeAccept: dateTime.data,
})

export const cleanErrors = () => ({
    type: CLEAN_ERRORS,
})

export const nextStage = (index, stageValidator) => ({
    type: NEXT_STAGE_PURCHASE_MOBILE,
    index,
    stageValidator,
})

export const selectPaymentCreditCard = (index) => ({
    type: STAGE_PAYMENT_CREDIT_CARD,
    stepDisplayCreditCard: index
})

export const selectBankCashTransfer = (index) => ({
    type: STAGE_PAYMENT_CASH_TRANSFER,
    stepDisplayCashTransfer: index
})

export const editPurchase = (index) => ({
    type: EDIT_PURCHASE,
    stagePurchase: index
})

export const selectPaymentMethodAlterStage = (index, name, value = null) => ({
    type: SELECT_PAYMENT_ALTER_STATE,
    index: value !== null ? value : index,
    name
})

export const backStagePaymentMethod = (index, name, condition) => ({
    type: BACK_STAGE_PAYMENT_METHOD,
    index,
    name,
    condition
})

export const backStagePurchase = (index) => ({
    type: BACK_STAGE_PURCHASE,
    stagePurchase: index
})

export const cleanStatesPurchaseMobile = () => ({
    type: CLEAN_STATES_PURCHASE_MOBILE
})

export const validatorHandlerBlur = (value, name, index = 0) => (dispatch, getState) => {
    dispatch({
        type: VALIDATOR_HANDLER_BLUR,
        value,
        name,
        index,
    });
}

export const setInfosProspect = (infos) => ({
    type: GET_INFOS_PROSPECT,
    infos,
})

export const setInfosProspectInPurchase = () => ({
    type: SET_INFOS_PROSPECT_IN_PURCHASE
})

export const clearInfosProspect = () => ({
    type: CLEAR_INFOS_PROSPECT
})

export const getInfosInsureds = (payment) => ({
    type: GET_INFOS_INSUREDS,
    payment,
})

export const fetchUserDetails = () => (dispatch) => {
  const url = `${process.env.REACT_APP_DJANGO_URL}${process.env.REACT_APP_PATH}/pedido/api/user-detail/`;
  const fetchOptions = {
    headers: {
      Authorization: process.env.REACT_APP_DJANGO_AUTHORIZATION_URL,
    },
  };

  return fetch(url, fetchOptions)
    .then((response) => response.json())
    .then((json) => dispatch(setUserDetails(json)));
};

export const getInfosProspect = () =>
    (dispatch) => {
        const infos = getCookie('infosprospect');
        const url = `${process.env.REACT_APP_DJANGO_URL}${process.env.REACT_APP_PATH}/pedido/api/purchase-data/${infos}/`;

        if (infos) {
            fetch(url, { method: 'GET' })
                .then(response => {
                    if (response.status !== 200)
                        return null;
                    response.json()
                        .then(json => {
                            const setProspect = {
                                exist: true,
                                name: json.name,
                                email: json.email,
                                phone: json.phone,
                            }
                            return dispatch(setInfosProspect(setProspect))
                        })
                })
        }
    }

export const getBenefits = () => (dispatch) => {

    const url = process.env.REACT_APP_GO_API_URL + '/benefits';

    const fetchOptions = {
        headers: {
            method: "GET",
            Authorization: process.env.REACT_APP_GO_AUTHORIZATION_URL,
        },
    };

    fetch(url, fetchOptions).then(response => {
        response.json().then(json => (
            dispatch(setBenefitsDescription(json))
        ))
    })
}

export const setBenefitsDescription = (benefits) => ({
    type: SET_BENEFITS,
    benefits
})

export const setOperatorConfirmationClicked = () => ({
    type: SET_OPERATOR_CONFIRMATION_CLICKED
})

export const setUpsellPurchase = (upsellProduct) => (dispatch) => {
    sessionStorage.setItem('upsellUpgrade', upsellProduct);
    dispatch({
        type: SET_UPSELL_PURCHASE,
        upsellProduct
    });
}




// WEBPACK FOOTER //
// ./src/actions/purchaseActions.js